var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m271 30.667v-30.667h-30v30.667c-137.792 6.879-241 108.299-241 240.333l.015 24.17 21.68-10.737c.263-.147 28.348-13.433 54.305-13.433 19.351 0 42.231 18.501 49.409 25.62l10.605 10.488 10.576-10.488c7.179-7.119 30.059-25.62 49.41-25.62 16.401 0 35.237 13.237 45 21.625v174.375c0 24.814 20.186 45 45 45s45-20.186 45-45v-30h-30v30c0 8.276-6.724 15-15 15s-15-6.724-15-15v-174.375c9.763-8.388 28.599-21.625 45-21.625 19.351 0 42.231 18.501 49.409 25.62l10.605 10.488 10.576-10.488c7.179-7.119 31.059-25.62 50.41-25.62 25.957 0 53.042 13.286 53.306 13.433l21.694 10.752v-24.185c0-132.034-103.208-233.454-241-240.333z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.f9d7dcca.svg";
export { ForwardRef as ReactComponent };